import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './reduxSlices';

const store = configureStore({
  reducer: rootReducer,
})

export default store;
